// export const serverPath = "https://techsmo5.d-keys.info";
export const serverPath = "https://d-keys.info";
// export const dkeysInfoBaseURL = "http://192.168.250.25:8663/";
export const dkeysInfoBaseURL = "https://dki.d-keys.ru:38258/";
export const l2BaseURL = "https://cmdc.s-m-d.ru:8626/openDoorByLink";
export const getRedirectsURL = `${serverPath}/scripts/getredirects.php`;
export const createRedirectURL = `${serverPath}/scripts/createredirect.php`;
export const updateRedirectURL = `${serverPath}/scripts/updateredirect.php`;
export const deleteRedirectURL = `${serverPath}/scripts/deleteredirect.php`;
export const getRedirectByIdURL = `${serverPath}/scripts/getredirect.php`;
// Base URL for HTML article endpoint (can be same as dkeysInfoBaseURL or different)
export const getArticleHTMLBaseURL = dkeysInfoBaseURL;
// export const getArticleHTMLBaseURL = "http://192.168.250.25:8663/";

export const chatApiBaseUrl = "http://chatwebsocket.smd.local:8756";
